{
  "record_windows.schedule_unavailable": "This schedule is no longer available",
  "record_windows.skip_occurrence_date": "Skip occurrence on {{date}}",
  "record_windows.skip_occurrence": "Skip this occurrence",
  "record_windows.planned": "Planned",
  "record_windows.actual": "Actual",
  "record_windows.open_source_routine": "Open source routine"
}
